/* eslint-disable import/first */
import React from 'react';
import icon from './storeIcon.svg';
export default function StoreLocatorIcon(props) {
  return <img src={icon} alt="store Icon" />;
}
